export default __webpack_public_path__ + "static/media/people.2cf0c391.svg";